import { WidgetType } from '@codemirror/view'
import { Root, createRoot } from 'react-dom/client'
import { TbExclamationCircle } from 'react-icons/tb'
import { uiColors } from '~/common/styles/colors'

/**
 * The error icon widget for the formula builder
 */
export class ErrorIconWidget extends WidgetType {
  private domNode: HTMLDivElement
  private root: Root

  constructor() {
    super()
    this.domNode = document.createElement('div')
    this.domNode.style.position = 'absolute'
    this.domNode.style.right = '12px'
    this.domNode.style.top = '5px'
    // Use ReactDOM.createRoot to render the component
    this.root = createRoot(this.domNode)
    this.root.render(<TbExclamationCircle color={uiColors.content.danger} size="16px" />)
  }

  toDOM() {
    return this.domNode
  }

  ignoreEvent() {
    return false // Allows events on the icon, change to true if you want to ignore
  }

  destroy() {
    // Schedule unmount asynchronously to avoid React 18 warnings about
    // unmounting during render
    setTimeout(() => {
      this.root.unmount()
    }, 0)
  }
}
